export default function TrustBar() {
  const stats = [
    { icon: 'ri-time-line', number: '16+', label: 'Years Experience' },
    { icon: 'ri-checkbox-circle-line', number: '500+', label: 'Projects Completed' },
    { icon: 'ri-team-line', number: 'Certified', label: 'Hardscape Installers' },
    { icon: 'ri-star-line', number: '5-Star', label: 'Highly Rated' },
    { icon: 'ri-shield-check-line', number: 'Licensed', label: '& Insured' }
  ];

  return (
    <div className="bg-[#F5F5F5] py-12 border-y border-gray-200">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              <div className="w-14 h-14 flex items-center justify-center mb-4 bg-white rounded-full shadow-md">
                <i className={`${stat.icon} text-3xl text-[#E67E22]`}></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-1">{stat.number}</div>
              <div className="text-sm text-gray-600 whitespace-nowrap">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}